export interface NewsArticles {
    ImagePath: string;
    NewsTitle: string;
    NewsDate: string;
    NewsSummary: string;
    NewsBody: string;
    Url: string;
    VideoUrl: string;
    Tags: string[];
    ArticleTypeTagText: string;
    ArticleTypeTagUrl: string;
    Categories: CategoryModel[];
}

export interface SearchResults<t> {
    Items: t[],
    TotalMatching: number,
    SearchQuery: string,
    SearchTag: string,
    PageSize: number,
    NoResultMessage: string,
    ResultFoundMessage: string,
    ContentTypesFilterFacets: FilterFacetItem[],
    DateRangeFacets: DateRangeFacetItem[],
    AuthorsTermFacets: TermFacetItem[],
    CategoriesTermFacets: TermFacetItem[],
    SortByOptions: any[],
    SortByLabel: string,
    RelatedQueries: Hits[]
}

export interface FilterFacetItem {
    Name: string,
    Value: string,
    Count: string,
    checked: boolean
}

export interface Hits {
    Suggestion: string,
    Type: string
}

export interface DateRangeFacetItem {
    StartDate: string,
    EndDate: string,
    DisplayName: string,
    checked: boolean
}

export interface TermFacetItem extends FilterFacetItem {
    Description: string
}

export interface SearchContent {
    ImageUrl: string;
    Title: string;
    Date: string;
    Tags: CategoryModel[];
    Summary: string;
    Url: string;
    IsMedia: boolean;
    ArticleType: string;
    ArticleTypeTagText: string;
    AuthorsTags: CategoryModel[];
}

export interface SearchStaticContent {
    NewsPageTitle: string;
    NoResultText: string;
    loadingMessage: string;
    FilterUrl: string;
    PageSize: number;
}

export interface EventAlbum {
    ImagePath: string,
    ImageIndex: number
}

export interface FamilyEvents {
    Year: string,
    Galleries: FamilyEventProperties[],
}

export interface FamilyEventProperties {
    CoverImage: string,
    CityCode: string,
    EventDate: string,
    EventPageLink: string,
}

export interface ValidValue {
    Label: string,
    Value: string
}
export interface ReportInputFields {
    HidePagination: boolean,
    SsrsInputFields: SsrsInputFields[],
    ReportName: string
}

export interface SsrsInputFields {
    IsRequired: boolean,
    Name: string,
    DisplayName: string,
    Type: string,
    Selections: ValidValue[],
    DefaultValues: string[],
    Value: string[],
    DefaultValue: string,
    IsReadonly: boolean,
    CheckboxListDefaultValues: string[]
}

export interface SsrsReportJson {
    Inputs: SsrsInputFields[],
    FileType: string
}

export interface HtmlKeyValue {
    Key: string,
    Value: string
}

export interface PowerBiEmbedConfig {
    ReportId: string,
    GroupId: string,
    EmbedUrl: string,
    AccessToken: string,
    Expiration: string
}

export interface ContractDetails {
    ContractAdminLink: string,
    ContractAdminLinkText: string,
    PDFDocumentLink: string,
    ContractSections: ContractSections[],
    Title: string,
    SearchTextPlaceholder: string,
}

export interface ContractSections {
    SectionName: string,
    SectionDivId: string,
    ContractItems: ContractItems[],
}

export interface ContractItems {
    ItemTitle: string,
    ContractItemBody: ContractItemBody,
    ContractItemDivId: string,
    ContractItemBodyString: string,
}

export interface ContractItemBody {
    Fragments: Fragments[];
}

export interface Fragments {
    InternalFormat: string
}

export interface CalendarEvent {
    title: string;
    type: string;
    start: string;
    end: string;
    backgroundColor: string;
    url: string;
}

export interface Podcast {
    ImagePath: string;
    PodcastTitle: string;
    PodcastDate: string;
    PodcastSummary: string;
    PlayerID: string;
    PodcastTranscript: string;
    Url: string;
    Tags: string[];
}

export interface CategoryModel {
    ID: string,
    Name: string,
    UrlFriendlyName: string,
    Description: string,
    GUID: string
}

export interface PolicyManualContent {
    Heading: string,
    ContentTextBody: any,
    PdfDocumentLink: string,
    BackToTopText: string
}

export enum SCREEN_SIZE {
    XS,
    SM,
    MD,
    LG,
    XL
}

export interface SliceShowMore {
    start: number,
    end: number,
    type: string,
    linkRefName: any
}

export interface ResolutionInputModel {
    DateRangeLabel: string,
    StartDateLabel: string,
    EndDateLabel: string,
    KeywordLabel: string,
    IdLabel: string,
    StatusLabel: string,
    NoResolutionsMessage: string,
    ValidationMessage: string
    ResolutionStatuses: ResolutionStatus[],
    StartDate: string,
    EndDate: string,
    Keyword: string,
    Id: string,
    PageSize: number
}


export interface ResolutionStatus {
    Id: string,
    Status: string,
    Description: string
}

export interface ResolutionsViewResults {
    ResodbId: string,
    Title: string,
    PDFLink: string,
    Status: string,
    ClosedDate: Date,
    ResolutionNo: string,
    AttachmentCount: number
}

export interface TTGAPairingGridResults {
    ID: string,
    Title: string,
    TTGAType: string,
    Domicile: string,
    Seat: string,
    From: Date,
    To: Date,
    Status: string,
}

export interface NetZeroPreferencesGridResults {
    ID: string,
    Title: string,
    Date: string,
    Domicile: string,
    Seat: string,
    NetZero: string,
    Status: string,
}

export interface SelectListItem {
    Disabled : boolean,
    Selected: boolean,
    Text : string,
    Value : string
}

export interface QnASearchResultViewModel<t> {
    Items: t[],
    Filters: SelectListItem[]
    TotalMatching: number,
    SearchQuery: string,
    SearchTag: string,
    PageSize: number,
    NoResultMessage: string,
    ResultFoundMessage: string,
    Sections: SelectListItem[]
}

export interface QuestionAndAnswer {
    Likes: number,
    Answer: string,
    AnsweredByUserId: string,
    AnsweredDate: Date,
    QuestionId: string,
    PageId: number,
    SectionName:string,
    Question: string,
    SubmittedBy: string,
    SubmittedDate: Date,
    Tags: string,
    Status: string,
    NoOfLikes: number,
    NoOfDislike: number,
    SubmittedByUserId: string,
    SubmittedDateInString: string,
    AnsweredDateInString: string,
    Action?: string,
    IsPinned?: boolean,
    IsAnonymous: boolean
}

export interface TocTabPageQnAViewAllBlockModel {
    CurrentPageId: number,
    PageSize: number,
    NoResultText: string,
    GetQnAFor: string
}

export interface DTCPreferencesGridResults {
    ID: string,
    Title: string,
    DTCDate: string,
    Domicile: string,
    Seat: string,
    DTCValue: string,
    Status: string,
}
